import { PagedRequestType, PagedResultsType } from "../../../types/PagedResults";
import { SubscriptionSubjectType, SubscriptionType } from "../../../types/Student";
import { get } from "../../../utils/axios-config";
import { SUBSCRIPTIONS_BY_STUDENT, SUBSCRIPTIONS_SUBJECTS } from "../../../utils/constants";

export const getSubscriptionsByStudent = async (data?: PagedRequestType) => {
    // const queryParams = new URLSearchParams({
    //     PageNumber: data?.PageNumber?.toString() || '1',
    //     PageSize: data?.PageSize?.toString() || '100',
    //     ...(data?.IdFaculty ? { IdFaculty: data.IdFaculty } : {}),
    //     ...(data?.IdDepartament ? { IdDepartament: data.IdDepartament } : {}),
    //     ...(data?.IdAcademicYear ? { IdAcademicYear: data.IdAcademicYear  } : {}),
    //     ...(data?.IdCourse ? { IdCourse: data.IdCourse  } : {}),
    //      ...(data?.Semester ? { Semester: `${data.Semester}`  } : {}),
    //      ...(data?.Level ? { Level: `${data.Level}`  } : {}),
    //      ...(data?.SearchTerm ? { SearchTerm: `${data.SearchTerm}`  } : {}),
    //      ...(data?.IdStudent ? { IdStudent: `${data.IdStudent}`  } : {}),
    // });
    const queryParams = new URLSearchParams(
        Object.entries(data!)
            .filter(([_, value]) => value !== undefined && value !== "")
            .reduce((acc, [key, value]) => {
                acc[key] = typeof value === "boolean" ? (value ? "1" : "0") : value.toString();
                return acc;
            }, {} as Record<string, string>)
    );
    const url = `${SUBSCRIPTIONS_BY_STUDENT}?${queryParams.toString()}`;
    return await get<PagedResultsType<SubscriptionType>>(url)
}; 